
















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class SocialMediaSharer extends Vue
{
  @Prop()
  message: string | null = null;
}
